import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Text } from '@chakra-ui/react';

import { CustomHeading } from 'shared-components';

import QuestionPage from '../../../templates/question';
import Checkbox from '../../../molecules/checkboxQuestion';
import { Q } from '../../../../store/student/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { Pages } from '../../../../store/student/consents/types';
import { saveConsents } from '../../../../store/student/actions';

export interface IDispatchProps {
  onNext: (config: any) => void;
  onBackToTaskList: () => void;
}

export interface IProps {
  sectionTitle: string;
  currentStep: number;
  steps: number;
  consent?: boolean;
  config: any;
}

type Props = IProps & IDispatchProps;

function ConsentsQPage1(props: Props) {
  const [consent, setConsent] = useState(props.consent || false);

  const dispatch = useDispatch();
  const onNext = (config: any) => dispatch(saveConsents(Pages.PAGE1, config));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  useEffect(() => {
    setConsent(props.consent || false);
  }, [props.consent, setConsent]);

  return (
    <QuestionPage
      complete={consent}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      <CustomHeading level={'h2'}>{props.config.Page1.heading}</CustomHeading>

      <Text
        fontSize="lg"
        dangerouslySetInnerHTML={{
          __html: props.config.Page1.blurb,
        }}
      />

      <Checkbox
        key={Q.CONSENTS_1}
        id={Q.CONSENTS_1}
        isTicked={consent}
        checkboxLabel={'I agree'}
        onChange={(_key: string, isTicked: boolean) => setConsent(isTicked)}
      />
    </QuestionPage>
  );
}

export default ConsentsQPage1;
